module.exports = __webpack_public_path__ + "img/nationwide_service_qr_code.dfc7e8f3.png";